/**
 * Primary navigation — four thumb-reachable destinations that map to the app's
 * real mental models: Today (daily ritual), Coach (per-thread conversation +
 * progress), Map (the whole-life Constellation), and You (account / settings).
 *
 * Renders as a fixed bottom tab bar on mobile and a slim left rail on desktop.
 * Replaces the old 9-control top strip.
 */

import { CalendarCheck, MessageSquare, Network, User, Compass } from 'lucide-react';

export const PRIMARY_TABS = [
  { key: 'today', icon: CalendarCheck, label: 'Today' },
  { key: 'coach', icon: MessageSquare, label: 'Coach' },
  { key: 'map', icon: Network, label: 'Map' },
  { key: 'you', icon: User, label: 'You' },
];

export function BottomTabBar({ activeTab, onSelect }) {
  return (
    <nav
      aria-label="Primary"
      className="md:hidden flex-shrink-0 border-t border-slate-800 bg-slate-950/95 backdrop-blur px-safe-2 pb-safe flex items-stretch"
    >
      {PRIMARY_TABS.map(({ key, icon: Icon, label }) => {
        const active = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onSelect(key)}
            aria-current={active ? 'page' : undefined}
            aria-label={label}
            data-tour={`tab-${key}`}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 min-h-tap py-1.5 text-[11px] font-medium transition-colors ${
              active ? 'text-blue-400' : 'text-slate-500 hover:text-slate-300'
            }`}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 2} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export function NavRail({ activeTab, onSelect }) {
  return (
    <nav
      aria-label="Primary"
      className="hidden md:flex flex-col items-stretch w-20 flex-shrink-0 border-r border-slate-800 bg-slate-950 pt-safe-3 pb-3"
    >
      <div className="flex items-center justify-center py-4 mb-1" title="The Navigator">
        <Compass size={22} className="text-blue-400" />
      </div>
      {PRIMARY_TABS.map(({ key, icon: Icon, label }) => {
        const active = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onSelect(key)}
            aria-current={active ? 'page' : undefined}
            className={`flex flex-col items-center justify-center gap-1 py-3 mx-2 my-0.5 rounded-lg text-[11px] font-medium transition-colors ${
              active ? 'text-blue-300 bg-slate-800/70' : 'text-slate-500 hover:text-slate-300 hover:bg-slate-800/40'
            }`}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 2} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
